import { Payments } from '@prisma/client';
import { useMutation } from '@tanstack/react-query';
import { sendPaymentReceipt } from '../../services/payments';

interface Options {
  onSuccess?: (result: Payments) => void | Promise<void>;
  onError?: (error: string) => void | Promise<void>;
}

function useSendPaymentReceipt({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async (paymentId: string) => {
      const result = await sendPaymentReceipt(paymentId);
      return result;
    },
    onSuccess,
    onError: err => {
      onError?.(err?.message);
    },
  });
}

export default useSendPaymentReceipt;
